import { CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressTrackerInitialTrackedId = string | null;

const initialState: ContractProgressTrackerInitialTrackedId = null;

export default function reducer(
  state: ContractProgressTrackerInitialTrackedId = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    default:
      return state;
  }
}
